import { useState, useCallback } from "react";
import { apiClient } from "../../utils/api";
import { useAuthStore } from "../../store/authStore";
import { AutoLoginResponse } from "../../types/auth";

interface UseAutoLoginReturn {
  autoLogin: () => Promise<boolean>;
  isAutoLogging: boolean;
}

export const useAutoLogin = (): UseAutoLoginReturn => {
  const [isAutoLogging, setIsAutoLogging] = useState(false);
  const { refreshToken: storedRefreshToken, signIn, signOut } = useAuthStore();

  const autoLogin = useCallback(async (): Promise<boolean> => {
    if (!storedRefreshToken || isAutoLogging) {
      return false;
    }

    setIsAutoLogging(true);

    try {
      const response = await apiClient.get<AutoLoginResponse>(
        "/api/v1/auth/auto/logined",
        {
          headers: {
            Authorization: storedRefreshToken,
          },
        }
      );

      const responseData = response.data;

      if (
        responseData.status &&
        responseData.access_token &&
        responseData.data
      ) {
        signIn(
          {
            accessToken: responseData.access_token,
            refreshToken: responseData.refresh_token,
          },
          responseData.data
        );
        return true;
      } else {
        // 자동 로그인 실패 시 로그아웃
        signOut();
        return false;
      }
    } catch (error) {
      console.error("자동 로그인 실패:", error);
      signOut();
      return false;
    } finally {
      setIsAutoLogging(false);
    }
  }, [storedRefreshToken, isAutoLogging, signIn, signOut]);

  return {
    autoLogin,
    isAutoLogging,
  };
};
